import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

const styles = {
  root: {
    position: 'absolute',
    top: 'calc(100% + 2px)',
    left: 0,
  },
};

export const DataGridErrorHelperText = ({ text = '*Required field' }) => {
  return (
    <Typography variant="overline" color="error" sx={styles.root}>
      {text}
    </Typography>
  );
};

DataGridErrorHelperText.propTypes = {
  text: PropTypes.string,
};
